var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVentCooling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 99,
    viewBox: "0 0 174 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171.853 16.51L156.663 1.32C154.903 -0.44 152.053 -0.44 150.303 1.32C148.543 3.08 148.543 5.93 150.303 7.68L157.813 15.19H138.333C126.453 15.19 115.293 19.81 106.893 28.21L90.9033 44.2L97.2633 50.56L113.253 34.57C119.953 27.87 128.853 24.18 138.323 24.18H157.803L150.293 31.69C148.533 33.45 148.533 36.3 150.293 38.05C151.173 38.93 152.323 39.37 153.473 39.37C154.623 39.37 155.773 38.93 156.653 38.05L171.843 22.86C173.603 21.1 173.603 18.25 171.843 16.5L171.853 16.51Z",
    fill: "url(#paint0_linear_1211_996)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.673 98.58H142.333C130.453 98.58 119.293 93.96 110.893 85.56L59.9133 34.58C53.2133 27.88 44.3133 24.19 34.8433 24.19H15.3633L22.8733 31.7C23.7533 32.58 24.1933 33.73 24.1933 34.88C24.1933 36.03 23.7533 37.18 22.8733 38.06C21.1133 39.82 18.2633 39.82 16.5133 38.06L1.3233 22.87C0.783295 22.32 0.413295 21.65 0.213295 20.93C0.153295 20.71 0.113295 20.49 0.0832953 20.27H0.0332953C-0.0567047 19.53 0.0332953 18.77 0.333295 18.05C0.333295 18.05 0.333295 18.05 0.333295 18.04C0.333295 18.04 0.333295 18.04 0.333295 18.03C0.563295 17.47 0.903295 16.98 1.3233 16.57L16.5133 1.32C18.2733 -0.44 21.1233 -0.44 22.8733 1.32C24.6333 3.08 24.6333 5.93 22.8733 7.68L15.3633 15.19H34.8433C46.7233 15.19 57.8833 19.81 66.2833 28.21L117.263 79.19C123.963 85.89 132.863 89.58 142.333 89.58H162.673C165.163 89.58 167.173 91.59 167.173 94.08C167.173 96.57 165.163 98.58 162.673 98.58Z",
    fill: "#A63333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1334 58.98L55.9234 79.19C49.2234 85.89 40.3234 89.58 30.8534 89.58H10.5034C8.01342 89.58 6.00342 91.59 6.00342 94.08C6.00342 96.57 8.01342 98.58 10.5034 98.58H30.8434C42.7234 98.58 53.8834 93.96 62.2834 85.56L82.4934 65.35L76.1334 58.99V58.98Z",
    fill: "url(#paint1_linear_1211_996)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1211_996",
    x1: 28.5933,
    y1: 130.77,
    x2: 159.413,
    y2: 6.98001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#A53333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#526684"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1211_996",
    x1: 10.2934,
    y1: 111.43,
    x2: 141.113,
    y2: -12.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#A53333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#526684"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentCooling);
export default __webpack_public_path__ + "static/media/vent_cooling.e15d9928c4e40765e8da97f48002397d.svg";
export { ForwardRef as ReactComponent };